<template>
  <div id="bottomOpenApp" class="bottom-open-app" v-show="bannerShow">
    <div class="icon">
      <img id="contentImg" v-bind:src="iconImg">
    </div>
    <div class="btn">
      <!--<span  class="">立即打开</span>-->
      <div style="float:right;width:100%;margin:10px 0; text-align: right;" id="btnOpenAppBanner" ref="btnOpenAppBanner">
        <img id="bottomCloseImg" style="float:right;width:18px;height:18px;margin-top: 7px;"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAV1BMVEUAAACqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqpHJnhUAAAAHHRSTlMA1BX6JAwHxzPrnJn12sGJV+l2PCW7tZ6qqWseIX1HXgAAARVJREFUOMuFU1uSgzAMU+KEJLzfbFvd/5w72/WU0NJBP0wsBxkjYYfvqzCIDKHqPT7hypov1KV7o4tOyHacbFHYaWxJ6YrDdUNu836eN9JkL4kDm4gDYsPhVXKJy8dYtmVyqm/YHgS1vND8lzs2FifwDbungDDiFJHyJ1JywxdsLAFfU2e5BVWy4abTs/bo2Wp/oLFP3jBoqWWPiiMAJYzVh5ZGVgickHfkPCYGJFrkHcprgQnCAnlHzqOgXDZcSlwOefmZ14vaV/2zr/onWzVKljiHUk7k2+8WmdUw/qth1HLrmeVWGv8y7eo/7q9M7tL2eXCkeuznRyU07j16styjB3y8L6LRyzEfw7vn8Bj/JJKO8f8FTVwUKr7FB8oAAAAASUVORK5CYII="
             @click="closeShow()"/>
        <span id="btnOpenAppSpan" class="btn-open themeBgColor openappAndroidwx wx-launch-app-btn-parent" v-html="">打开</span>

        <!--<a id="btnOpenApp" ng-show="isOpenMagicWindowOperateFlag ==1" style="color: #ffffff;font-size: 16px;width:80px;height:30px;border-radius: 5px;-->
        <!--background-color: #13b7f6;padding: 2px 6px;color: white;margin-right: 5px;" ng-bind="transOpenNow">-->

        <!--</a>-->
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '../tool/utils'
  const _userAgent = window.navigator.userAgent
  const _agent = _userAgent.indexOf('xkyApp') === -1
  // const _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') > -1
  import $ from 'jquery'

  export default {
    props: ['sid', 'themeColor'],
    data () {
      return {
        iconUrl: '',
        downloadBarBgColor: '',
        bannerShow: false,
        iconImg: `https://${this.$route.params.sid}oss.newaircloud.com/global/user/${this.$route.params.sid}/mobile/img/base_bottom_logo.png`,
        downAppHref: '',
        openAppScheme: ''
      }
    },
    beforeMount () {
      const _self = this
      _self.downAppHref = sessionStorage.getItem('downAppHref')

      if (_agent) {
        // 非新空云客户端
        // if (_self.downAppHref == null) {
        //   setTimeout(() => {
        //     _self.downAppHref = sessionStorage.getItem('downAppHref')
        //     if (_self.downAppHref == null) {
        //       // axios.get(`https://oss.newaircloud.com/global/user/${this.sid}/mobile/global.js`, {
        //       //   headers: {
        //       //     'Content-Type': 'application/javascript'
        //       //   }
        //       // })
        //       //   .then((res) => {
        //       //     const ap = /"downAppUrl":"(.+)",/
        //       //     const arrAp = res.data.match(ap)
        //       //     this.downAppHref = arrAp[1]
        //       //   })
        //       //   .catch(function (error) {
        //       //     console.log(error)
        //       //   })
        //       $.ajaxSetup({
        //         cache: true
        //       })
        //       $.getScript(`https://oss.newaircloud.com/global/user/${this.$route.params.sid}/mobile/global.js`).then(function (script, textStatus) {
        //         if (typeof gUserConfig !== 'undefined') {
        //           // eslint-disable-next-line no-undef
        //           _self.downAppHref = gUserConfig.downAppUrl
        //         }
        //       })
        //     }
        //   }, 1000)
        // }
        // if (this.sid) {
        //   this.iconImg = `//oss.newaircloud.com/global/user/${this.sid}/mobile/img/base_bottom_logo.png`
        // }
        // eslint-disable-next-line eqeqeq
        if (utils.getUrlParam('hideBanner') == 1 || window.gUserConfig.isMobileShowFixBottom != 1) {
          this.bannerShow = false
        } else {
          window.gUserConfig.downloadBarPosition = window.gUserConfig.downloadBarPosition || 0
          // 下载条放置到顶部，同时顶部设置相应的padding高度
          // eslint-disable-next-line eqeqeq
          if (window.gUserConfig.downloadBarPosition == 0) {
            this.bannerShow = true
            document.querySelector('body').style['padding-bottom'] = '55px'
            // eslint-disable-next-line eqeqeq
          } else if (window.gUserConfig.downloadBarPosition == 1) {
            document.querySelector('body').style['padding-bottom'] = '0px'
            if (window.gUserConfig.bgColor) {
              this.downloadBarBgColor = window.gUserConfig.bgColor
            }
            this.bannerShow = false
          } else {
            // 显示在顶部和底部
            // let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            document.querySelector('body').style['padding-bottom'] = '55px'
            // console.log('scrollTop', $(document).scrollTop())
            if ($(document).scrollTop() > 50) {
              this.bannerShow = true
            } else {
              this.bannerShow = false
            }
            window.addEventListener('scroll', () => {
              if ($(document).scrollTop() > 50) {
                this.bannerShow = true
              } else {
                this.bannerShow = false
              }
            })
          }
        }
      } else {
        this.bannerShow = false
      }
    },
    methods: {
      closeShow () {
        this.bannerShow = false
      },
      openAppOrHref () {
        this.$emit('topicToApp')
      }
    }
  }
</script>

<style>
  .bottom-open-app {
    position: fixed;
    width: 100%;
    height: 55px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, .5);
    z-index: 999;
    /*background: rgba(220, 136, 52, 0.5);*/
  }

  .icon {
    float: left;
    width: 58.33333333%;
    padding-left: 10px;
  }

  .icon img {
    float: left;
    height: 40px;
    margin: 5px;
    margin-top: 7px;
  }

  .btn {
    float: right;
    width: 41.66666667%;
    padding-right: 10px;
  }

  .btn-open {
    float: right;
    color: #ffffff;
    /*font-size: 14px;*/
    /*width: 80px;*/
    /*height: 27px;*/
    /*line-height: 27px;*/
    /*border-radius: 5px;*/
    background-color: var(--themeColor);
    /*padding: 2px 6px;*/
    margin-right: 5px;
    text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 30px;
    /*height: 32px;*/
    font-size: 14px;
    line-height: 16px;
    padding: 8px 30px;
    border-radius: 30px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// BottomOpenApp.vue?82b684f0